// Release-wide UI switch. Not a permission or a backend/native writer switch.
// Deliberately not overridable through query strings, local storage or personas.
export const NFC_UI_VISIBLE = false;

export function attendanceUiText(value, fallback = 'Evento presenza') {
  if (value == null) return value;
  if (NFC_UI_VISIBLE) return value;
  const text = String(value);
  if (/\b(?:EV2|NTAG\d*|SUN)\b/i.test(text) || /(?:nfc|ev2)[._]/i.test(text)) return fallback;
  if (text === 'NFC verificato') return 'Presenza verificata';
  return text.replace(/\bNFC\b/gi, 'Presenze');
}
